class SlaS4 {
    id = 0;
    sa4code = 0;
    sa4name = '';
    statename = '';
    factsheet = '';
    postcode = '';
}

export default SlaS4;